import { useEffect } from 'react';
import { REPLAY_DISABLED_IN_DOCUMENT_EDITOR } from '@/config/env';
import { pauseSessionReplay } from '@/lib/sentry-replay';

/**
 * Mount this on the document editor page. In builds with
 * VITE_DISABLE_REPLAY_IN_DOCUMENT_EDITOR=true, Sentry Session Replay is paused
 * for as long as the page is mounted and resumed on the way out.
 */
export function useDocumentEditorReplayPolicy(): void {
  useEffect(() => {
    if (!REPLAY_DISABLED_IN_DOCUMENT_EDITOR) return;
    return pauseSessionReplay();
  }, []);
}
